module.exports = __webpack_public_path__ + "static/img/背景板(4).013f50dc.png";